module.exports = __webpack_public_path__ + "img/ez-slot-category-new-released.4423ae03.png";